<template>
  <b-row>
    <b-col class="content">
      <!-- search form -->
      <b-overlay :show="searchIsRunning" rounded="sm" spinner-variant="primary">
        <SearchForm :params="model.params" @search="runSearch" />
      </b-overlay>
      <hr>
      <template v-if="!searchIsRunning && model.params.done">
        <BusResult
              v-for="(result,resultIndex) in model.results"
              :result="result"
              :key="'result' + resultIndex"
              :expanded="resultIndex === 0"
              :params="model.params"
              :showBook="true"
              @toggle="onToggle(result)"
              @book="onBook({ resultId: resultIndex })"
              @priceDetails="onPriceDetails({ result })"
              />
      </template>
    </b-col>
    <b-modal v-model="priceDetailsModal" title="Price Details" size="lg" hide-header hide-footer>
      <SimpleModalHeader @closeModal="closePriceDetailsModal" />
      <PriceDetails
        :title="priceDetailsParams.title"
        :meal="priceDetailsParams.meal"
        :serviceTax="priceDetailsParams.serviceTax"
        :discounts="priceDetailsParams.discounts"
        :paymentSchedule="priceDetailsParams.paymentSchedule"
      />
      <ModalFooter @closeModal="closePriceDetailsModal" />
    </b-modal>
  </b-row>
</template>

<script>
import model from './services/model'
import viewMixin from '../shared/mixins/search_views'
import SearchForm from './components/search_form.vue'
import BusResult from './components/result.vue'
import PriceDetails from '@/app/private/shared/components/price_details'
import SimpleModalHeader from '../shared/components/simple_modal_header'
import ModalFooter from '../shared/components/modal_footer'

export default {
  mixins: [viewMixin],
  components: { SearchForm, BusResult, PriceDetails, SimpleModalHeader, ModalFooter },
  data () {
    return {
      model,
      searchIsRunning: false,
      collapsed: true,
      priceDetailsParams: {
        meal: null,
        title: '',
        discounts: [],
        paymentSchedule: [],
        serviceTax: 0
      },
      priceDetailsModal: false
    }
  },
  methods: {
    runSearch (params) {
      this.searchIsRunning = true
      model.search(params)
        .finally(() => { this.searchIsRunning = false })
    },
    onBook ({ resultId }) {
      const route = {
        name: 'Private/Bus/Book',
        params: {
          Result: resultId
        }
      }
      this.$router.push(route)
    },
    async onPriceDetails ({ result }) {
      this.priceDetailsParams.title = result.label
      this.priceDetailsParams.meal = result
      this.priceDetailsParams.discounts = []
      this.priceDetailsModal = true
    }
  }
}
</script>
